export default "__VITE_ASSET__2Pm2hkQa__"